import { fork } from 'redux-saga/effects';

import { saga as commonSaga } from './common';
import { saga as identitySaga } from './identity';

function* saga() {
    yield fork(commonSaga);
    yield fork(identitySaga);
}

export { saga };
